import { fieldCantBeEmptyMsg, messageOrQuestionMsg, t } from '../../../common/i18n/index.js';
import { TextAreaComponent } from '../components/TextAreaComponent.js';
import type { OptionalInputComponentProps } from '../components/InputComponent.js';

export const Message = ({
  className,
  label = t.FJLH(messageOrQuestionMsg),
  name = 'message',
  placeholder = t.FJLH(messageOrQuestionMsg),
  required = false,
  rows,
}: OptionalInputComponentProps & { rows?: number }) => {
  const validate = (value: string) => {
    if (required && !value) {
      return t.VPVR(fieldCantBeEmptyMsg);
    }
    return undefined;
  };

  return (
    <TextAreaComponent
      disabled={false}
      label={label}
      name={name}
      placeholder={placeholder}
      required={required}
      rows={rows}
      validate={validate}
      wrapperClassName={className}
    />
  );
};
